import { useState } from 'react';
import { Alert, Button, MenuItem, Stack, Typography } from '@mui/material';
import { DialogSurface, FormTextField } from '../../../design-system';
import type { PeopleFilters, PeopleViewPreferencesPort } from '../operations/peopleWorkspace';

export function PeopleSavedViews({ preferences, filters, onApply, onClose, onChanged }: {
  preferences: PeopleViewPreferencesPort;
  filters: PeopleFilters;
  onApply: (filters: PeopleFilters) => void;
  onClose: () => void;
  onChanged: (message: string) => void;
}) {
  const [views, setViews] = useState(() => preferences.read());
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const save = () => {
    const normalized = name.trim();
    if (!normalized || normalized.length > 40) { setError('필터 이름은 1~40자로 입력해 주세요.'); return; }
    if (views.length >= 20) { setError('최대 20개까지 저장할 수 있습니다. 사용하지 않는 필터를 삭제해 주세요.'); return; }
    if (views.some((view) => view.name === normalized)) { setError('이미 저장된 이름입니다. 다른 이름을 입력해 주세요.'); return; }
    const next = [...views, { id: crypto.randomUUID(), name: normalized, filters: { ...filters } }];
    try { preferences.write(next); onChanged('조회 조건을 저장했습니다.'); onClose(); } catch { setError('이 브라우저에 저장하지 못했습니다. 브라우저의 저장 공간 설정을 확인해 주세요.'); }
  };
  return <DialogSurface open onClose={onClose} title="검색·필터 저장" help="이 브라우저에서 현재 계정의 검색·필터 조건을 저장합니다. 기준일은 저장하지 않습니다." size="standard" actions={<><Button onClick={onClose}>닫기</Button><Button variant="fill" onClick={save}>현재 조건 저장</Button></>}>
      <Stack spacing={2}>
        {error && <Alert severity="error">{error}</Alert>}
        {views.length > 0 && <FormTextField select size="small" label="저장한 필터" value="" onChange={(event) => {
          const view = views.find((item) => item.id === event.target.value);
          if (view) { onApply({ ...view.filters }); onClose(); }
        }} fullWidth>
          <MenuItem value="">선택</MenuItem>{views.map((view) => <MenuItem key={view.id} value={view.id}>{view.name}</MenuItem>)}
        </FormTextField>}
        <FormTextField label="필터 이름" value={name} onChange={(event) => setName(event.target.value)} slotProps={{ htmlInput: { maxLength: 40 } }} fullWidth />
        {views.map((view) => <Stack key={view.id} direction="row" sx={{ alignItems: 'center' }} spacing={1}>
          <Typography variant="body2" sx={{ flex: 1 }}>{view.name}</Typography>
          <Button size="small" color="error" onClick={() => {
            const next = views.filter((item) => item.id !== view.id);
            try { preferences.write(next); setViews(next); setError(''); onChanged('저장한 필터를 삭제했습니다.'); } catch { setError('저장한 필터를 삭제하지 못했습니다.'); }
          }}>삭제</Button>
        </Stack>)}
      </Stack>
    </DialogSurface>;
}
